import { isStatusCodeError } from './isStatusCodeError.ts';

export const isTooManyRequestsError = (error: Parameters<typeof isStatusCodeError>[0]): boolean =>
	isStatusCodeError(error, '429');
